import React, { useContext } from "react";
import { Button, message, Modal, Input } from "antd";
import { YhBox } from "@/erp_subpackage/components/YhBox";
import { usePurchaseRoModel } from "../purchaseRoModel";
import { DataTable } from "./DataTable";
import { MyContext } from "@/store/myContext";
import { formatNum } from "@/erp_subpackage/utils/util";
import { DictCodeEnmu } from "@/erp_subpackage/utils/DictCodeEnum";

export const DataBox = () => {
    const { selectedRowKeys, descTotal, rowsDescTotal, searchParam, shopId, setPrint, exportList, invalidate, exportDetail } = usePurchaseRoModel();
    const { state, dispatch, detailsPage } = useContext(MyContext);

    //新增 查看 编辑
    const goPageNav = (mode, rowCode) => {
        let tabName = {
            add: "采购退货新增",
            edit: "采购退货编辑",
            look: "采购退货查看",
        }
        let modeKey = "purchaseRo/" + mode;

        //动态传入要删除的nav key
        const handleDispatch = (obj = {}) => {
            dispatch({
                ...obj,
                type: "changeTabs",
                name: tabName[mode],
                activeMenu: modeKey,
                content: detailsPage.PurchaseRoDetails({
                    modeKey,
                    mode,
                    dispatch,
                    rowCode: rowCode ?? selectedRowKeys[0]?.returnCode
                }),
            })
        }

        if (mode === "edit") {
            const findNav = state.panes.find(item => item.key === modeKey);
            if (findNav) {
                Modal.confirm({
                    title: '温馨提醒！',
                    content: "您还有采购退货详情未保存，是否跳转",
                    okText: '跳转未保存页',
                    cancelText: '打开新页签',
                    onOk: () => {
                        handleDispatch()
                    },
                    //打开新页签重新生成
                    onCancel: () => {
                        handleDispatch({ deleteKey: modeKey })
                    }
                });
                return;
            }
            handleDispatch()
        }
        else if (mode === "add") {
            handleDispatch()
        }
        else if (mode === "look") {
            handleDispatch({ deleteKey: modeKey })
        }
    }

    //作废
    const cancellation = () => {
        if (selectedRowKeys.length !== 1) {
            message.warning("请选择单条数据进行编辑，点击鼠标右键可一键选中哦！")
            return;
        }
        let cancelReason = ""
        Modal.confirm({
            title: '采购退货单作废',
            type: "error",
            content: <><span>请输入作废原因</span>
                <Input onChange={(e) => { cancelReason = e.target.value }} /></>,
            okText: '确定',
            cancelText: '取消',
            onOk: () => new Promise((resolve, reject) => {
                if (cancelReason) {
                    resolve(cancelReason);
                } else {
                    message.warning("请输入作废原因");
                    reject('请输入作废原因');
                }
            }).then(res => {
                invalidate(res);
            }),
        });
    }

    const action = <>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => {
                goPageNav("add")
            }}
        >新增</Button>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning("请选择单条数据进行编辑，点击鼠标右键可一键选中哦！")
                    return;
                }
                if (selectedRowKeys[0].status === DictCodeEnmu.PRO_CHANGE) {
                    message.warning("已作废的单据不可以进行编辑");
                    return;
                }
                if (selectedRowKeys[0].status === DictCodeEnmu.PRO_STOCK_IO) {
                    message.warning("已出库的单据不可以进行编辑");
                    return;
                }
                goPageNav("edit")
            }}
            disabled={searchParam.shopId === "" || (searchParam.shopId && searchParam.shopId !== shopId)}
        >编辑</Button>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning("请选择单条数据进行查看，点击鼠标右键可一键选中哦！")
                    return;
                }
                goPageNav("look")
            }}
        >查看</Button>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => exportList()}
        >导出</Button>
        {/* <Button
            className="btn-item"
            shape="round"
            onClick={() => exportDetail()}
        >导出明细</Button> */}
        <Button
            className="btn-item"
            shape="round"
            onClick={cancellation}
            disabled={searchParam.shopId === "" || (searchParam.shopId && searchParam.shopId !== shopId)}
        >作废</Button>
        <Button
            className="btn-item"
            shape="round"
            onClick={() => {
                setPrint(true)
            }}
        >打印</Button>
    </>;

    const desc = [
        {
            label: "退货总量",
            value: !selectedRowKeys.length ? descTotal.totalNum : rowsDescTotal.totalNum,
            color: "red"
        },
        {
            label: "退货总金额",
            value: !selectedRowKeys.length ? descTotal.totalAmount : formatNum(rowsDescTotal.totalAmount),
            color: "red"
        },
        {
            label: "已收金额",
            value: !selectedRowKeys.length ? descTotal.paidAmount : formatNum(rowsDescTotal.paidAmount),
            color: "red"
        }
    ]

    return (
        <YhBox title="采购退货列表" action={action} descriptions={desc}>
            <DataTable goPageNav={goPageNav} />
        </YhBox>
    )
}

